import { useEffect, useState } from "react";

export type ImageDimensions = { width: number; height: number };

export function useImageDimensions(src: string | null | undefined): ImageDimensions | null {
    const [dimensions, setDimensions] = useState<ImageDimensions | null>(null);

    useEffect(() => {
        setDimensions(null);
        if (!src) return;

        let cancelled = false;
        const image = new Image();
        image.onload = () => {
            if (!cancelled) setDimensions({ width: image.naturalWidth, height: image.naturalHeight });
        };
        image.src = src;

        return () => {
            cancelled = true;
        };
    }, [src]);

    return dimensions;
}
